export enum DurationEnum {
  Y = '/ year',
  S = '/ semi-annual',
  M = '/ month',
  Q = '/ quarter',
  T = '/ trimester',
  D = '/ day'
}
